import { TrashIcon, ArrowUpTrayIcon } from "@heroicons/react/24/solid";
import { Button } from "@headlessui/react";
import { DownloadRosterButton } from "../../schools/SchoolRosterSection";
import DragAndDropUpload from "./DragAndDropUpload";

const EXCEL_ACCEPT =
	".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel";

interface RosterUploadProps {
	fileName?: string;
	onFileSelected: (file?: File) => void;
	onUpload: () => void;
	isLoading: boolean;
	disableUpload: boolean;
}

export default function RosterUpload({
	fileName,
	onFileSelected,
	onUpload,
	isLoading,
	disableUpload,
}: RosterUploadProps) {
	return (
		<div className="flex justify-center">
			<div className="flex flex-col w-2xl">
				<DragAndDropUpload
					accept={EXCEL_ACCEPT}
					label="Drag & drop roster file here"
					fileName={fileName}
					onFileSelected={onFileSelected}
					isLoading={isLoading}
				/>
				<div className="flex justify-between mt-2 flex-col sm:flex-row gap-2">
					<DownloadRosterButton disabled={isLoading} className="w-full" />
					<div className="flex gap-2 justify-end flex-col sm:flex-row">
						{fileName && (
							<Button
								type="button"
								className="!flex flex-row justify-center items-center btn btn-neutral"
								disabled={isLoading}
								onClick={() => onFileSelected(undefined)}>
								<TrashIcon className="size-4 mr-2" aria-hidden="true" />
								Remove
							</Button>
						)}
						<Button
							type="button"
							className="!flex flex-row justify-center items-center btn btn-primary"
							disabled={!fileName || isLoading || disableUpload}
							onClick={onUpload}>
							<ArrowUpTrayIcon className="size-4 mr-2" aria-hidden="true" />
							Upload
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
}
